<template>
  <main>
    <b-container>
      <div class="section-header">
        <h1 class="heading">Import</h1>
        <div class="action"></div>
      </div>
      <div class="layoutcard">
        <b-input-group>
          <b-form-file v-model="file"></b-form-file>
          <b-input-group-append>
            <b-btn @click="uploadJson" variant="outline-secondary">
              <b-spinner v-if="uploading" small />
              Import
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </div>

      <div class="section-header">
        <h1 class="heading">Import Steps</h1>
        <div class="action"></div>
      </div>
      <div class="layoutcard">
        <table class="table table-hover vertical-align-middle">
          <tbody>
            <tr>
              <th width="80%">Import Pools</th>
              <td>
                <b-spinner
                  v-if="poolAddStatus && poolAddStatus !== ' Complete'"
                  small
                /><span>{{ poolAddStatus || "Not Yet Started" }}</span>
              </td>
            </tr>
            <tr>
              <th width="80%">Process Pools</th>
              <td>
                <b-spinner
                  v-if="poolProcessStatus && poolProcessStatus !== ' Complete'"
                  small
                /><span>{{ poolProcessStatus || "Not Yet Started" }}</span>
              </td>
            </tr>
            <tr>
              <th width="80%">Import Projects with Models</th>
              <td>
                <b-spinner
                  v-if="projAddStatus && projAddStatus !== ' Complete'"
                  small
                /><span>{{ projAddStatus || "Not Yet Started" }}</span>
              </td>
            </tr>
            <!--<tr>
            <th width="80%">Calculate Model</th>
            <td><b-spinner v-if="isExploring || isCalculating" small /><span>{{ calcModel || "Not Yet Started" }}</span></td>
          </tr>
          <tr>
            <th width="80%">Import analysis</th>
            <td><b-spinner v-if="addAnalysis" small /><span>{{ addAnalysis || "Not Yet Started" }}</span></td>
          </tr>
          <tr>
            <th width="80%">Import Filters</th>
            <td><b-spinner v-if="addFilters" small /><span>{{ addFilters || "Not Yet Started" }}</span></td>
          </tr>
          <tr>
            <th width="80%">Import Settings</th>
            <td><b-spinner v-if="addSettings" small /><span>{{ addSettings || "Not Yet Started" }}</span></td>
          </tr>-->
          </tbody>
        </table>
      </div>
    </b-container>
  </main>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "Import",
  extends: InitAdmin,
  data() {
    return {
      file: null,
      pool: null,
      poolInterval: null,
      uploading: false,
      importData: null,
      poolAddStatus: null,
      poolProcessStatus: null,
      projAddStatus: null,
      calcModel: null,
      isCalculating: false,
      isExploring: false,
      loadedPools: [],
      loadedProjects: [],
    };
  },
  computed: {
    ...mapState({
      importedFile: (state) => state.impexp.importedFile,
    }),
    ...mapGetters([]),
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions([
      "importFile",
      "saveImportFile",
      "addPool",
      "loadPool",
      "updatePool",
      "processPool",
      "saveProject",
      "addModelToProject",
      "loadProjects",
    ]),
    uploadJson() {
      this.uploading = true;
      const formData = new FormData();
      formData.append("file", this.file);
      this.importFile(formData).then((res) => {
        this.uploading = false;
        this.startImport(res);
      });
    },
    async startImport(importData) {
      /*let imported = this.importedFile;
                  imported.status = {
                    pools: true,
                    process: true,
                    projects: true,
                    calculate: true,
                    settings: false,
                    filters: false,
                    analysis: false
                  }
                  this.saveImportFile(imported).then(() => {
                    
                  });*/
      await this.importPools(importData.pools);
      await this.processPools();
      clearInterval(this.poolInterval);
      await this.importProjects(importData.projects);
      this.startCalculate();
    },
    async importPools(pools) {
      return new Promise((resolve, reject) => {
        let k = 1;
        this.poolAddStatus = " Starting";
        pools.forEach((pool, i) => {
          setTimeout(() => {
            this.addPool({
              obj: {
                name: pool.name,
                source: pool.dbtype,
                description: pool.description,
                refresh: true,
              },
            }).then((id) => {
              this.poolAddStatus = " Added Pool: " + pool.name;
              let npool = {
                id: id.data,
                poolid: pool._id,
                name: pool.name,
                dbtype: pool.dbtype,
                description: pool.description,
                uploaddata: pool.uploaddata,
                isimport: "Yes",
                refresh: true,
              };
              this.loadedPools.push(npool);
              this.updatePool({ id: id.data, pool: npool }).then((res) => {
                if (k === pools.length) {
                  this.poolAddStatus = " Complete";
                  let imported = this.importedFile;
                  imported.status = {
                    pools: true,
                    process: false,
                    projects: true,
                    calculate: false,
                    settings: false,
                    filters: false,
                    analysis: false,
                  };
                  this.saveImportFile(imported).then(() => {
                    resolve();
                  });
                }
                k++;
              });
            });
          }, i * 1000);
        });
      });
    },
    async processPools() {
      let imported = this.importedFile;
      return new Promise((resolve, reject) => {
        let k = 1;
        this.loadedPools.forEach(async (pool) => {
          await this.processIt(pool);
          if (k === this.loadedPools.length) {
            imported.status.process = true;
            this.saveImportFile(imported);
            resolve();
          }
          k++;
        });
      });
    },
    async processIt(pool) {
      return new Promise((resolve, reject) => {
        this.poolProcessStatus = " Processing " + pool.name;
        this.processPool({ id: pool.id, filename: pool.poolid }).then((res) => {
          if (res.data.status === "ok") {
            const checkPoolStatus = () => {
              this.loadPool({ id: pool.id }).then((pool) => {
                if (pool.status.code === 4) {
                  this.poolProcessStatus = " Complete";
                  resolve();
                }
              });
            };
            this.poolInterval = setInterval(checkPoolStatus, 1000);
            checkPoolStatus();
          }
        });
      });
    },
    async importProjects(projects) {
      return new Promise((resolve, reject) => {
        let k = 1;
        this.projAddStatus = " Starting";
        projects.forEach((proj, i) => {
          const data = {
            name: proj.name,
            description: proj.description,
            tag: proj.tag,
          };
          this.saveProject({
            project: data,
            refresh: true,
          }).then((res) => {
            proj.projectModels.forEach((model) => {
              let poolid = this.loadedPools.find(
                (p) => p.poolid === model.pools[0].pool_id
              ).id;
              const pools = [
                {
                  pool_id: poolid,
                  documents: null,
                  filter: null,
                  type: "derwent",
                },
              ];
              const mdata = [];
              mdata.projectId = res._id;
              mdata.pool_ids = pools;
              mdata.topicing_method = "internal";
              mdata.name = model.name;
              mdata.description = model.description;
              this.addModelToProject(mdata).then((res) => {
                this.loadedProjects.push(res.data);
                this.projAddStatus = " Added " + proj.name;
                if (k === projects.length) {
                  this.projAddStatus = " Complete";
                  let imported = this.importedFile;
                  imported.status.projects = true;
                  this.saveImportFile(imported);
                  resolve();
                }
                k++;
              });
            });
          });
        });
      });
    },
    startCalculate() {
      this.loadProjects().then(() => {
        this.$router.push({
          name: "ProjectView",
          params: { id: this.loadedProjects[0]._id },
        });
      });
    },
  },
};
</script>